import {
  CLEAR_REQUEST_ID,
  STORE_REQUEST_SUBMITTED_ID,
} from '../actions/requestSubmittedDetailsAction';

const initialState = { requestId: null };

export const requestSubmittedDetailsReducer = (
  // eslint-disable-next-line default-param-last
  state = initialState,
  action
) => {
  switch (action.type) {
    case STORE_REQUEST_SUBMITTED_ID: {
      return {
        ...state,
        requestId: action.payload.requestId,
        isRoleRequest: action.payload.isRoleRequest,
      };
    }

    case CLEAR_REQUEST_ID: {
      return initialState;
    }

    default:
      return state;
  }
};

export default requestSubmittedDetailsReducer;
